/* eslint-disable @atlaskit/editor/no-re-export */
// Entry file in package.json

import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var pluginKey = new PluginKey('tablePlugin');